import { Link } from "react-router-dom";
import { Check, Clock, Wrench, SearchCode } from "lucide-react";

export function Ticket({data}) {
  return (
        <Link
          key={data.id}
          to={`/suporte?ticket=${data.id}`}
          className="w-full group rounded-lg border-zinc-200/30 shadow-md border p-2 gap-4 flex items-center justify-center transition scale-95 duration-500 hover:scale-100 hover:duration-200 hover:bg-zinc-100 hover:border-zinc-400/30"
        >
          <div
            style={{ backgroundColor: data.color }}
            className="w-11 h-11 rounded-md flex items-center justify-center p-2  border-zinc-200/30 shadow-md border"
          >
            {data.code === 'waiting' && <Clock className="w-full h-full text-white" />}
            {data.code === 'progress' && <Wrench className="w-full h-full text-white" />}
            {data.code === 'analysis' && <SearchCode className="w-full h-full text-white" />}
            {data.code === 'completed' && <Check className="w-full h-full text-white" />}
            {data.code === 'validation' && <Check className="w-full h-full text-white" />}
          </div>
          <div className="flex flex-col w-[calc(100%_-_3.75rem)]">
            <p className="text-sm font-semibold w-full truncate text-zinc-600 transition-colors duration-500 group-hover:duration-200 group-hover:text-zinc-900">{data.title}</p>
            <p className="text-xs font-light w-full truncate  text-zinc-400 transition-colors duration-500 group-hover:duration-200 group-hover:text-zinc-500">ID:{data.id}</p>
          </div>
        </Link>
  );
}
